import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const DELETE_BIDDER: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation deleteWorkspaceBidder($input: DeleteWorkspaceBidderInput!) {
    deleteWorkspaceBidder(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
